import React, { ReactElement } from "react"
import { useWeb3React } from "@web3-react/core"
import { SUPPORTED_WALLETS } from "../constants"
import { logEvent } from "../utils/googleAnalytics"
import { map } from "lodash"
import Text from "./Text"
import { Box } from "@mui/material"
import Button from "./Button"
import { useTranslation } from "react-i18next"
import Modal from "./Modal"
import { updateWalletConnector } from "src/state/user"
import { useDispatch } from "react-redux"
import { WALLET_CONNECTOR } from "src/constants"
// import { hasSwitchFunction, switchNetwork } from "src/utils/connectors"

interface Props {
  onClose: () => void
}

function ConnectWalletModal({ onClose }: Props): ReactElement {
  const { t } = useTranslation()
  const { activate, deactivate, account } = useWeb3React()
  const dispatch = useDispatch()

  return (
    <Modal open onClose={onClose} title={t("Connect Wallet")}>
      <div data-testid="connectWalletContainer">
        <Box display="flex" alignItems="center" justifyContent="center" mt={1}>
          {map(SUPPORTED_WALLETS, (wallet, key) => (
            <Box
              key={wallet.name}
              onClick={async () => {
                await activate(wallet.connector, undefined, true).catch((e) => {
                  console.error(e)
                  void activate(wallet.connector)
                })
                dispatch(updateWalletConnector(key as WALLET_CONNECTOR))
                logEvent("change_wallet", { name: wallet.name })
                onClose()
              }}
              mx={2}
              textAlign="center"
              sx={{ cursor: "pointer", ["&:hover"]: { opacity: 0.8 } }}
            >
              <img src={wallet.icon} alt="icon" height={30} />
              <Text>{wallet.name}</Text>
            </Box>
          ))}
        </Box>
        {account && (
          <Button
            mt={2}
            fullWidth
            onClick={() => {
              deactivate()
              onClose()
              dispatch(updateWalletConnector(null))
            }}
            kind="outline"
          >
            {t("Disconnect")}
          </Button>
        )}
      </div>
    </Modal>
  )
}

export default ConnectWalletModal
